/**
 * Utility functions for building additional filter options in property search filters
 */

/**
 * Builds an array of feature options from filterData categories
 * @param {Object} filterData - Filter data object containing categories
 * @returns {Array<{value: string, label: string}>} Array of feature options
 */
export const buildFeatureOptions = (filterData) => {
  return Array.isArray(filterData?.categories)
    ? filterData.categories.map((type) => ({ value: type, label: type }))
    : [];
};

/**
 * Builds an array of buying scheme options from filterData buyingSchemes
 * @param {Object} filterData - Filter data object containing buyingSchemes
 * @returns {Array<{value: string, label: string}>} Array of buying scheme options
 */
export const buildBuyingSchemeOptions = (filterData) => {
  return Array.isArray(filterData?.buyingSchemes)
    ? filterData.buyingSchemes.map((type) => ({ value: type, label: type }))
    : [];
};
